import { defineComponent as _defineComponent } from 'vue'
import tooltip from "../tooltip/Tooltip.vue";

  
export default /*#__PURE__*/_defineComponent({
  __name: 'TreeView',
  props: {
    items: { default: () => [] },
    getDisabledText: { default: () => { return } },
    fetchChildren: { default: () => { return } },
    search: { default: '' },
    openItems: { default: () => [] },
    activeItems: { default: () => [] }
  },
  emits: ["updateActiveItems", "updateOpenItems"],
  setup(__props: any, { emit }: { emit: ({
    (e: 'updateActiveItems', items:object[]): void;
    (e: 'updateOpenItems', items:object[]): void;
  }), expose: any, slots: any, attrs: any }) {

  


  
  

  function updateActiveItems(active: object[]) {
    emit('updateActiveItems', active)
  }

  function updateOpenItems(openItems: object[]) {
    emit('updateOpenItems', openItems)
  }


return { __sfc: true,emit, updateActiveItems, updateOpenItems, tooltip }
}

})